module.exports = __webpack_public_path__ + "fea584012bdcaad9d64423ca11e6a4ca.png";